import reducer from './reducer';

export const { addNotification, removeNotification } = reducer.actions;
